/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

type ViewStateStoreDataType = {
  isRequesting: boolean;
};

type ViewStateType = {
  data: ViewStateStoreDataType;
  initialized: boolean;
};

const initialState = (): ViewStateType => ({
  data: {
    isRequesting: false,
  },
  initialized: false,
});

export const useViewStateStore = defineStore({
  id: 'viewState',
  state: initialState,
  getters: {
    isRequesting: (state) => state.data.isRequesting,
  },
  actions: {
    $reset() {
      Object.assign(this, initialState());
    },
    startRequesting(): void {
      this.data.isRequesting = true;
    },
    stopRequesting(): void {
      this.data.isRequesting = false;
    },
  },
});
